import { render, staticRenderFns } from "./plan-header.vue?vue&type=template&id=31abdb4a&scoped=true&"
import script from "./plan-header.component.ts?vue&type=script&lang=ts&"
export * from "./plan-header.component.ts?vue&type=script&lang=ts&"
import style0 from "./plan-header.scss?vue&type=style&index=0&id=31abdb4a&lang=scss&scoped=true&"
import style1 from "./plan-header.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31abdb4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31abdb4a')) {
      api.createRecord('31abdb4a', component.options)
    } else {
      api.reload('31abdb4a', component.options)
    }
    module.hot.accept("./plan-header.vue?vue&type=template&id=31abdb4a&scoped=true&", function () {
      api.rerender('31abdb4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery/components/plan-header/plan-header.vue"
export default component.exports